export default function ParcelRequestForm() {
  return <div className="w-full md:w-1/2 mx-auto p-4"></div>;
}
